<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-card>
      <v-card-title tag="h2" class="text-subtitle-1 font-weight-medium">{{ $t('homeBanner') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <!-- Banner List -->
        <v-form ref="dataForm" @submit.prevent="">
          <draggable
            v-model="formData.online_course_banner_list"
            :disabled="$store.getters.isLoading"
            @change="$store.dispatch('setDataIsUpdated', true)"
          >
            <div class="py-4" v-for="(item, i) in formData.online_course_banner_list">
              <div class="pa-4 d-flex">
                <v-icon class="drag-icon mr-2 mr-sm-6" size="40" color="colorBlack">
                  {{ icon.mdiArrowLeftRight }}
                </v-icon>
                <div class="flex-grow-1">
                  <div class="d-flex align-start justify-space-between">
                    <div class="banner-preview rounded">
                      <v-img
                        :src="getFile(item.image)"
                        cover
                        width="100%"
                        height="100%"
                        @click="previewFile(item.image)"
                      ></v-img>
                    </div>
                    <FormButton color="error" text="delete" class="ml-4" @click="deleteBanner(i)" />
                  </div>
                  <FormInput
                    class="mt-6"
                    label="bannerHyperLink"
                    placeholder="bannerHyperLink"
                    :fieldValue.sync="item.link"
                    dispatchUpdateOnChange
                  />
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </draggable>
        </v-form>
        <!-- Upload Area -->
        <div class="pa-4">
          <v-file-input
            v-show="false"
            id="upload-banner-input"
            :accept="$common.getAcceptFileFormat(['image']).formatStr"
            @change="uploadFile($event)"
            :disabled="$store.getters.isLoading || $store.getters.isUploading"
            v-model="bannerFile"
          ></v-file-input>
          <div class="upload-banner-area rounded" v-ripple @click="triggerUploadFile()">
            <div class="text-h6 d-flex align-center">
              <v-icon class="fi fi-rr-plus mr-2" size="20"></v-icon>{{ $t('addImage') }}
            </div>
            <div class="text-caption mt-2">{{ $t('supportFileFormat', { format: 'png, jpeg, jpg' }) }}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <div class="d-flex align-center mt-4">
      <FormButton @click="save()" />
    </div>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import { mdiArrowLeftRight } from '@mdi/js'
import FormInput from '@/components/formField/FormInput.vue'

export default {
  name: 'HomeSetting',
  components: {
    draggable,
    FormInput,
  },
  computed: {},
  data: () => ({
    formData: {
      online_course_banner_list: [],
    },
    bannerFile: null,
    icon: {
      mdiArrowLeftRight,
    },
  }),
  methods: {
    async _getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          online_course_banner_list: this.formData.online_course_banner_list,
        }
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // ==================== 新增圖片 ====================
    triggerUploadFile() {
      if (this.$store.getters.isLoading || this.$store.getters.isUploading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      if (document.getElementById('upload-banner-input')) {
        document.getElementById('upload-banner-input').click()
      }
    },
    async uploadFile(file) {
      if (file) {
        const fileFormatArr = this.$common.getAcceptFileFormat(['image']).formatArr
        const check = this.$validate.validateFileInput(file, fileFormatArr)
        if (this.$validate.DataValid(check)) {
          this.$store.dispatch('toggleSnack', {
            message: this.$t(check.message, check.value || {}),
            type: 'error',
          })
        } else {
          this.$store.dispatch('setUploadLoading', true)

          try {
            const data = await this.$Fetcher.UploadFileNew(file)
            this.formData.online_course_banner_list.push({ image: data, link: '' })
            this.$store.dispatch('setDataIsUpdated', true)
          } catch (err) {
            this.$common.error(err)
            this.$store.dispatch('toggleSnack', {
              message: 'message.uploadFail',
              type: 'error',
            })
          } finally {
            this.$store.dispatch('setUploadLoading', false)
            this.bannerFile = null
          }
        }
      }
    },
    getFile(file) {
      return `${this.$mediaPath}${file}`
    },
    previewFile(file) {
      if (!file) return
      this.$store.dispatch('openMediaPopup', { media: this.getFile(file) })
    },
    deleteBanner(index) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.formData.online_course_banner_list.splice(index, 1)
      this.$store.dispatch('setDataIsUpdated', true)
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: HomeSetting')
      await this._getSetting()
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
<style lang="scss" scoped>
.upload-banner-area {
  width: 100%;
  border: 2px dashed var(--v-primary-base);
  cursor: pointer;
  min-height: 300px;
  padding: 1em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.drag-icon {
  transform: rotate(90deg);
  cursor: grab;
}

.banner-preview {
  width: 100%;
  max-width: 800px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: relative;
    width: 100%;
    height: auto;
    pointer-events: none;
    display: block;
    position: relative;
    padding-top: 56%;
  }

  & > .v-image {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
